var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easyscreen-qr-code"},[(_vm.$easyscreenIsMobile)?_c('a',{staticClass:"easyscreen-qr-code--link",attrs:{"href":_vm.qrCodeLink}},[_vm._v(" "+_vm._s(_vm.$l10n("Open in browser"))+" ")]):_c('div',{staticClass:"easyscreen-qr-code--wrapper"},[_c('div',{staticClass:"easyscreen-qr-code--image",style:(_vm.style)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }